import { useDispatch as useReduxDispatch } from 'react-redux';//useSelector
import { configureStore } from '@reduxjs/toolkit';
import axios from 'axios';

//for storage
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import Reducers from './reducers';

  const persistConfig = {
    key: 'root',
    storage,
  }

//   const Reducers = combineReducers({
//     fieldreducer: FieldsReducer,
//      loginreducer : LoginReducer,
//      modalState : ModalPopupReducer,
// })


  
const persistedReducer = persistReducer(persistConfig, Reducers)
const store = configureStore({
    reducer: {
    reducers: persistedReducer,
    //Reducers,
    //middleware:(getDefaultMiddleware)=>getDefaultMiddleware(),
    },
    devTools: true,
    // devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]//added
});
export const useDispatch = () => useReduxDispatch();
const persister = persistStore(store);
//export const persistor = persistStore(store)

const { dispatch } = store;
axios.interceptors.request.use(function (config) {
  //console.log("request")
  dispatch({ type: "SHOW_LOADING_SPINNER", payload: true});
 
  return config;
}, function (error) {
  alert(error)
  dispatch({ type: "HIDE_LOADING_SPINNER", payload: true});
  setTimeout(() => {   }, 1000)
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  //console.log("response")
 dispatch({ type: "HIDE_LOADING_SPINNER", payload: true});
  return response;
}, function (error) {
  dispatch({ type: "HIDE_LOADING_SPINNER", payload: true});
  setTimeout(() => {  }, 1000)
  return Promise.reject(error);
})
//persister
export { store,persister };